module.exports = __webpack_public_path__ + "static/projections-6df12eb4c6aeb112bdbc42e022f37e56.png";